import { useGetRegionPageAvailableParticipants } from 'api/regions/hooks';
import { useFetchLocationAvailableParticipants } from 'api/locations/hooks';
import { useFetchRetailerPageAvailableParticipants, useFetchStore } from 'api/store/hooks';
import { useParams } from 'react-router-dom';
import { useSelectedProfileStore } from 'stores/selectedProfileStore';

export const useLocationArtistAvailableItems = () => {
  const { locationUid } = useParams();
  const { data, isLoading } = useFetchLocationAvailableParticipants(locationUid);

  return { items: data || [], isLoading };
};

export const useStoreArtistAvailableItems = () => {
  const { data: store } = useFetchStore();
  const { data, isLoading } = useFetchRetailerPageAvailableParticipants(store?.uid, {
    enabled: !!store?.uid,
  });

  return { items: data || [], isLoading };
};

export const useRegionArtistAvailableItems = () => {
  const selectedRegion = useSelectedProfileStore((state) => state.selectedRegionUid);
  const { data, isLoading } = useGetRegionPageAvailableParticipants(selectedRegion);

  return { items: data || [], isLoading };
};
